import React from 'react'
import { isNumber } from 'lodash'
import { Glyphicon, Button, ButtonGroup } from 'react-bootstrap'
import PropTypes from "prop-types"

import { ModalExpenseEditor } from './ExpenseEditor.jsx'
import getEmptyExpense from '../lib/emptyExpense.js'

import { getText } from '../lib/text.js'
import { moveInArray } from '../../lib/Tools'
import { CutePriceTag } from './Price';

const props = {
  onChange: PropTypes.func.isRequired, // (string, any) => void,
  expenses: PropTypes.arrayOf(PropTypes.object).isRequired,
  Activities: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired, 
  priceValues: PropTypes.objectOf(PropTypes.number).isRequired
}

const defaultProps = { }

/**
 * #TODO for some reason this component is rerendered constantly, even
 * when only the hovered day in the Agenda changes. 
 */

class ExpensesList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { editingIdx: null }
  }

  render() {
    const { onChange, expenses } = this.props
    const expense = expenses[this.state.editingIdx]
    
    const column = expenses.map((x, i) => (
      <div 
        key={x._id}
        style={{
          position: "relative",
          minHeight: 20,
          padding: 5,
          borderTopColor: "darkGrey",
          borderTopWidth: 2,
          borderTopStyle: "solid",
          borderLeftStyle: "solid",
          borderLeftWidth: 10,
          backgroundColor: "rgb(230,230,230)"
        }}
      >
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <div style={{ maxWidth: "65%" }}>
            <h1 style={{ fontSize: 16, fontWeight: "bold", marginTop: 0 }}>
              <Glyphicon glyph="euro" />
              <strong>{x.name} / {x.title ? x.title : `[${getText("Falta título")}]`}</strong>
            </h1>
          </div>
          <div style={{ position: "absolute", right: 0, top: 0 }}>
            <CutePriceTag
              priceValue={this.props.priceValues[x._id]}
              style={{ float: "left", marginLeft: 5 }}
            />

            <ButtonGroup style={{ marginLeft: "5px" }}>
              <Button
                style={{ marginRight: "5px" }}
                bsSize="xsmall"
                onClick={() => this.setState({ editingIdx: i })}
              >
                <Glyphicon glyph="pencil" />
              </Button>
              <Button
                bsSize="xsmall"
                onClick={() => (i != 0 && onChange(moveInArray(expenses, i, i - 1)))}
              >
                <Glyphicon glyph="triangle-top" />
              </Button>
              <Button
                style={{ marginRight: "5px" }}
                bsSize="xsmall"
                onClick={() => (i < expenses.length - 1 && onChange(moveInArray(expenses, i, i + 1)))}
              >
                <Glyphicon glyph="triangle-bottom" />
              </Button>

              <Button
                style={{ marginRight: "5px" }}
                bsSize="xsmall"
                onClick={() => onChange(expenses.filter((ignored, j) => j != i))}
              >
                <Glyphicon glyph="remove" />
              </Button>
            </ButtonGroup>
          </div>

        </div>
      </div>
    ))

    return (
      <div style={{ marginBottom: "30px" }}>
        <div style={{
          position: "relative",
          minHeight: 20,
          padding: 5,
          borderTopColor: "darkGrey",
          borderLeftColor: "red",
          borderTopWidth: 2,
          borderTopStyle: "solid",
          borderLeftStyle: "solid",
          borderLeftWidth: 10,
          backgroundColor: "rgb(230,230,230)"
        }}
        >
          <h1 style={{ fontSize: 16, fontWeight: "bold", marginTop: 0 }}>
            <strong>{getText("Gastos generales")}</strong>
          </h1>
        </div>

        {column}

        <div style={{
          position: "relative",
          minHeight: 20,
          padding: 5,
          borderTopColor: "darkGrey",
          borderTopWidth: 2,
          borderTopStyle: "solid",
          textAlign: "center"
        }}
        >
          <Button
            disabled={this.props.mode == "add"}
            onClick={() => {
              const name = prompt(getText("Nombre del gasto"))
              this.setState({ editingIdx: expenses.length })
              if (name) {
                onChange(expenses.concat({ ...getEmptyExpense(), name }))
              }
            }}
          >
            <Glyphicon glyph="plus" /> {getText("Añadir gasto general")}
          </Button>
        </div>

        {
          isNumber(this.state.editingIdx) && expenses[this.state.editingIdx] && (
            <ModalExpenseEditor
              expense={expense}
              onChange={changes => onChange(expenses.map((ix, i) => (
                i == this.state.editingIdx ? { ...expense, ...changes } : ix)))
              }
              onClose={() => this.setState({ editingIdx: null })}
              isGeneralExpense={true}
            />
          )
        }
      </div>
    )
  }
}

ExpensesList.defaultProps = defaultProps

export default ExpensesList
